import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './my-profile.component'
import RegistrationContactsBlock from '../common/registration-contacts-block'

let module = angular.module('myProfile', [
  uiRouter,
  RegistrationContactsBlock
])
.config(($stateProvider) => {
  'ngInject'
  $stateProvider
    .state('registration.myProfile', {
      url: '/my-profile?civility&lastName&firstName&email&model&friendlyName&vin',
      component: 'myProfile',
      params: {
        password: null
      }
    })
})
.component('myProfile', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/registration/my-profile/index.js